
































































import Movie from '@/models/soukai/Movie';

import { ImportOperationLog } from '@/services/Media';

import Markdown from '@/utils/Markdown';

import ErrorInfoModal from '@/components/modals/ErrorInfoModal.vue';
import ImportResultModalItem from '@/components/modals/ImportResultModalItem.vue';
import MarkdownModal from '@/components/modals/MarkdownModal.vue';
import Modal from '@/components/mixins/Modal';

export default Modal.extend({
    components: {
        ImportResultModalItem,
    },
    props: {
        log: {
            type: Object as () => ImportOperationLog,
            required: true,
        },
    },
    computed: {
        watchedMovies(): Movie[] {
            return this.log.added.filter(movie => movie.watched);
        },
        pendingMovies(): Movie[] {
            return this.log.added.filter(movie => !movie.watched);
        },
    },
    methods: {
        inspectWatched() {
            let counter = 0;
            const logs = ['# These movies have been imported as watched'];

            for (const movie of this.watchedMovies) {
                logs.push(`${++counter}. ${movie.title}`);
            }

            this.$ui.openModal(MarkdownModal, { content: logs.join('\n') });
        },
        inspectPending() {
            let counter = 0;
            const logs = ['# These movies have been imported to watch later'];

            for (const movie of this.pendingMovies) {
                logs.push(`${++counter}. ${movie.title}`);
            }

            this.$ui.openModal(MarkdownModal, { content: logs.join('\n') });
        },
        inspectIgnored() {
            let counter = 0;
            const logs = ['# The following movies have been ignored'];

            for (const { reason, data } of this.log.ignored) {
                logs.push(`${++counter}. ${reason}`);
                logs.push(Markdown.codeBlock(JSON.stringify(data)));
            }

            this.$ui.openModal(MarkdownModal, { content: logs.join('\n') });
        },
        inspectUnprocessed() {
            let counter = 0;
            const logs = ['# The following movies have not been processed'];

            for (const data of this.log.unprocessed) {
                logs.push(`${++counter}. `);
                logs.push(Markdown.codeBlock(JSON.stringify(data)));
            }

            this.$ui.openModal(MarkdownModal, { content: logs.join('\n') });
        },
        inspectInvalid() {
            let counter = 0;
            const logs = ['# The following items were not valid movies'];

            for (const { reasons, data } of this.log.invalid) {
                logs.push(`${++counter}. ${reasons.join(', ')}`);
                logs.push(Markdown.codeBlock(JSON.stringify(data)));
            }

            this.$ui.openModal(MarkdownModal, { content: logs.join('\n') });
        },
        inspectFailed() {
            let counter = 0;
            const logs = ['# The following movies caused some errors'];

            for (const { notFound, error, data } of this.log.failed) {
                if (notFound) {
                    logs.push(`${++counter}. ${error.message}`);
                } else {
                    logs.push(
                        `${++counter}. An unexpected error ocurred parsing this — `+
                            `<a href="custom:${counter - 1}">view details</a>`,
                    );
                }

                logs.push(Markdown.codeBlock(JSON.stringify(data)));
            }

            this.$ui.openModal(MarkdownModal, {
                content: logs.join('\n'),
                handleCustomTrigger: (index: string) => {
                    this.$ui.openModal(ErrorInfoModal, { error: this.log.failed[parseInt(index)].error });
                },
            });
        },
    },
});
